import React from 'react';
import PropTypes from 'prop-types';
import Collapse from '@material-ui/core/Collapse';

import MenuItem from 'bento-ordering/menus/components/MenuItem';
import MenuSectionGrid from 'bento-ordering/menus/ui_components/MenuSectionGrid';

class MenuSectionList extends React.Component {
  static propTypes = {
    isExpanded: PropTypes.bool.isRequired,
    menuList: PropTypes.array,
    handleClick: PropTypes.func.isRequired,
    shouldLazyLoadMenu: PropTypes.bool
  };

  renderMenuSectionList = () => {
    const { handleClick, menuList, shouldLazyLoadMenu } = this.props;

    return (
      <MenuSectionGrid>
        {menuList.map(menuItem => {
          return (
            <MenuItem
              {...menuItem.product}
              key={menuItem.id}
              id={menuItem.id}
              inventory={menuItem.inventory}
              inventoryLessCart={menuItem.inventoryLessCart}
              handleClick={() => handleClick(menuItem.product.slug)}
              shouldLazyLoadMenu={shouldLazyLoadMenu}
            />
          );
        })}
      </MenuSectionGrid>
    );
  };

  render() {
    return (
      <Collapse in={this.props.isExpanded}>
        {this.renderMenuSectionList()}
      </Collapse>
    );
  }
}

export default MenuSectionList;
